import { render, staticRenderFns } from "./RuleQuery.vue?vue&type=template&id=1b8a267c"
import script from "./RuleQuery.vue?vue&type=script&lang=js"
export * from "./RuleQuery.vue?vue&type=script&lang=js"
import style0 from "./RuleQuery.vue?vue&type=style&index=0&id=1b8a267c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports